// extracted by mini-css-extract-plugin
export default {"container":"root_container__0f5JT","message":"root_message__MbgyY"};